<template lang="pug">
  .result
    h3.result-title ส่วนที่ 2 :  ประวัติการศึกษาและทักษะต่างๆ

    .education-item(v-for="(item, index) in education")
      h4.result-subtitle(v-if="!item.default && item.level") {{ item.level }}
      h4.result-subtitle(v-else) {{ item.title }}

      .result-item
        .row
          .col-sm-4
            .row
              strong.col-sm-4 ระดับการศึกษา 
              span.col-sm-8 {{ item.level }}

          .col-sm-4
            .row
              strong.col-sm-4.text-right เข้าศึกษา
              span.col-sm-8 {{ item.since }}

          .col-sm-4
            .row
              strong.col-sm-5.text-right สำเร็จการศึกษา
              span.col-sm-7 {{ item.to }}

      .result-item
        .row
          .col-sm-4
            .row
              strong.col-sm-4 สถานศึกษา
              span.col-sm-8 {{ item.institut }}

          .col-sm-4
            .row
              strong.col-sm-4.text-right สาขาวิชา
              span.col-sm-8 {{ item.field_of_study }}

          .col-sm-4
            .row
              strong.col-sm-5.text-right เกรด / คะแนนเฉลี่ย
              span.col-sm-7 {{ item.grade }}
</template>
<script>
import { mapState } from 'vuex'
export default {
  data: () => ({
    users: [],
  }),

  computed: {
    ...mapState(['education'])
  },

  methods: {
    generate(){
      this.education.push({
        title: 'ระดับการศึกษา',
        level: '',
        start_year: '',
        end_year: '',
        institut: '',
        field_of_study: '',
        grade: '',
        default: false,
      });

      this.$store.commit('SET_EDUCATION', this.education)
    },

    remove(e, index){
      this.$delete(this.education, index)
      this.$store.commit('SET_EDUCATION', this.education)
      // e.target.parentNode.parentNode.parentNode.removeChild(e.target.parentNode.parentNode)
    },

    onChange() {
      this.$store.commit('SET_EDUCATION', this.education) 
    }
  },
}
</script>

<style lang="scss" scoped>
.education {
  &-item {
    margin-bottom: 4rem;
  }

  &-add {
    width: 100%;
    text-align: center;
    color: #0f4c98;
    font-size: 20px;
    line-height: 1;
    font-weight: 600;
    display: block;
    padding: 2rem 0;
    background: #f5f5f5;
    border: none;
    outline: none;
  }

  &-remove {
    position: absolute;
    right: 4rem;
    color: #fff;
    font-size: 18px;
    line-height: 1;
    border: none;
    padding: 0.5rem 1rem;
    background: #0f4c98;
    outline: none;
  }
}
</style>